import React from 'react';
import styled from 'styled-components';
import { header400, defaultSmall } from '../../../shared/typography';
import Modal from '../../../shared/components/Modal';
import { gray1, gray7, surface } from '../../../shared/colours';

const Container = styled.div`
  width: 425px;
  background-color:${gray1};
  padding: 16px 16px 16px 16px;
  border-radius: 10px;
  box-sizing: unset !important;
`;

const HeadText = styled.div`
  ${header400}
  color: ${surface};
`;

const SubText = styled.div`
  ${defaultSmall}
  color: ${gray7};
  margin: 8px 0px 16px 0px;
`;

const ImageContainer = styled.img`
  border-radius: 10px;
`;

interface Props{
  isOpen: boolean,
  setModalClosed: ()=>void,
  headText?: string,
  subText?: string,
  imgSrc?: string,
}

export default function HelpIconInfoModal({
  isOpen, setModalClosed, headText, subText, imgSrc,
}:Props) {
  return (
    <Modal isOpen={isOpen} setModalClosed={setModalClosed} isHeadless>
      <Container>
        <HeadText>{headText}</HeadText>
        <SubText>{subText}</SubText>
        <ImageContainer src={imgSrc} height={200} width={400} />
      </Container>
    </Modal>
  );
}

HelpIconInfoModal.defaultProps = {
  headText: '',
  subText: '',
  imgSrc: '',
};
